import { createFormHook } from "@tanstack/react-form";
import { fieldContext, formContext } from "./form-context";
import { ParticipantField } from "./components/ParticipantField";
import { FormSubmitButton } from "./components/FormSubmitButton";

export const { useAppForm: useAddParticipantForm } = createFormHook({
    fieldContext,
    formContext,
    fieldComponents: { ParticipantField },
    formComponents: { FormSubmitButton },
});
